(() => {
  const consentSelector = '[data-pm-consent-input]';
  const checkoutSelector = '[data-pm-checkout]';

  function syncConsent(scope = document) {
    scope.querySelectorAll(consentSelector).forEach((input) => {
      const component = input.closest('cart-items-component') || document;
      const button = component.querySelector(checkoutSelector);
      if (!button) return;

      const accepted = input.checked;
      button.setAttribute('aria-disabled', accepted ? 'false' : 'true');
      button.dataset.pmConsentReady = accepted ? 'true' : 'false';
    });
  }

  function rejectCheckout(button) {
    const component = button.closest('cart-items-component') || document;
    const input = component.querySelector(consentSelector);
    if (!input || input.checked) return false;

    const status = component.querySelector('[data-pm-consent-status]');
    if (status) status.textContent = 'Debes aceptar ambas políticas para continuar.';
    input.focus({ preventScroll: true });
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches(consentSelector)) return;
    syncConsent(event.target.closest('cart-items-component') || document);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(checkoutSelector);
    if (!button || button.getAttribute('aria-disabled') !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    rejectCheckout(button);
  });

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter?.matches(checkoutSelector)) return;
    if (rejectCheckout(submitter)) event.preventDefault();
  });

  const observer = new MutationObserver(() => syncConsent());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncConsent());
  } else {
    syncConsent();
  }
})();
